@if (anchor) {
  <a [id]="anchor"></a>
}
@if (attributes.headline) {
  <h2 kb-heading type="divider" [appEditorId]="editorIds?.headline">{{attributes.headline}}</h2>
}

<kb-column-list [attr.kb-grid-item-columns]="attributes.parentNumColumns || attributes.numColumns">
  @for (item of attributes.items; track item) {
    <a kb-download-link
      [kbRouterOrExternalLink]="item.attributes.url"
      [fileType]="item.attributes.type"
      [bytes]="item.attributes.size"
      [appEditorId]="item.editorId"
    >
      {{item.attributes.label}}
    </a>
  }
</kb-column-list>
@if (createSectionButton) {
  <app-fs-button [value]="createSectionButton"></app-fs-button>
}
